var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { th } from '@xstyled/system';
// style object https://react-select.com/styles
export var CustomStyles = {
    control: function (styles, _a) {
        var _b;
        var selectProps = _a.selectProps, theme = _a.theme, isFocused = _a.isFocused, isDisabled = _a.isDisabled;
        var colors = theme.colors;
        return __assign(__assign({}, styles), { borderColor: selectProps.isInvalid ? colors.primary : isFocused ? colors.inputTextColor : colors.inputBorderColor, backgroundColor: isDisabled ? colors.menuHoverBackgroundColor : colors.whiteBackgroundColor, boxShadow: theme.focusBoxShadow, borderRadius: theme.borderRadius, '& input': {
                fontWeight: theme.textWeightNormal,
                fontFamily: theme.font,
            }, '&:hover': __assign(__assign({}, ((_b = styles['&:hover']) !== null && _b !== void 0 ? _b : {})), { borderColor: colors.inputBorderHoverColor }), fontSize: '14px', minWidth: 'min-content', '.inputIcon': {
                color: isDisabled ? colors.defaultControlColor : !!selectProps.value ? colors.inputTextColor : colors.defaultControlColor,
            } });
    },
    valueContainer: function (styles, _a) {
        var theme = _a.theme;
        return __assign(__assign({}, styles), { width: '50px', flexWrap: theme.flexWrap });
    },
    singleValue: function (styles, _a) {
        var selectProps = _a.selectProps, theme = _a.theme, isDisabled = _a.isDisabled;
        return __assign(__assign({}, styles), { position: 'absolute', top: '50%', transform: 'translateY(-50%)', color: selectProps.isInvalid
                ? theme.colors.primary
                : isDisabled
                    ? theme.colors.disabledTextColor
                    : theme.colors.inputTextColor, fontSize: '14px', fontWeight: theme.textWeightNormal });
    },
    multiValue: function (styles, state) {
        var theme = state.theme;
        return __assign(__assign({}, styles), { color: theme.colors.inputTextColor, fontWeight: theme.textWeightNormal, backgroundColor: '#E7EBEF', borderRadius: '4px', '& svg': {
                color: theme.colors.inputTextColor,
            }, ' > div': {
                fontSize: '12px',
            } });
    },
    multiValueLabel: function (styles) { return (__assign(__assign({}, styles), { fontSize: 'unset', padding: '5px' })); },
    multiValueRemove: function (styles, _a) {
        var theme = _a.theme;
        return (__assign(__assign({}, styles), { color: theme.colors.inputBorderColor }));
    },
    placeholder: function (styles, state) {
        var theme = state.theme, selectProps = state.selectProps;
        return __assign(__assign({}, styles), { fontSize: '14px', fontWeight: theme.textWeightNormal, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 'calc(100% - 8px)', color: selectProps.isDarkPlaceholderText ? theme.colors.inputTextColor : theme.colors.placeholderTextColor });
    },
    loadingMessage: function (styles, _a) {
        var theme = _a.theme;
        return (__assign(__assign({}, styles), { color: theme.colors.optionTextColor }));
    },
    noOptionsMessage: function (styles, _a) {
        var theme = _a.theme;
        return (__assign(__assign({}, styles), { color: theme.colors.optionTextColor }));
    },
    input: function (styles, _a) {
        var theme = _a.theme;
        return (__assign(__assign({}, styles), { color: theme.colors.inputTextColor }));
    },
    option: function (styles, _a) {
        var isSelected = _a.isSelected, theme = _a.theme, isDisabled = _a.isDisabled, selectProps = _a.selectProps;
        var defaultColor = theme.colors.optionTextColor;
        return {
            color: isSelected ? theme.colors.primary : defaultColor,
            backgroundColor: isSelected ? theme.colors.activeOptionBackground : undefined,
            fontWeight: theme.textWeightNormal,
            fontSize: '14px',
            cursor: !isDisabled ? 'pointer' : 'default',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '7px 10px',
            minHeight: '36px',
            marginRight: '4px',
            marginBottom: '2px',
            lineHeight: '22px',
            borderRadius: th.radius('ml')({ theme: selectProps === null || selectProps === void 0 ? void 0 : selectProps.systemTheme }),
            '&:hover': {
                backgroundColor: isSelected
                    ? theme.colors.hoverToActiveOptionBackground
                    : !isDisabled
                        ? theme.colors.menuHoverBackgroundColor
                        : undefined,
            },
        };
    },
    menu: function (styles, state) {
        var theme = state.theme;
        return __assign(__assign({}, styles), { boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.10);', marginTop: '4px', paddingTop: '0', borderRadius: '10px', zIndex: 3, minWidth: 'max-content', backgroundColor: theme.colors.whiteBackgroundColor });
    },
    menuList: function (styles, _a) {
        var theme = _a.theme;
        return __assign(__assign({}, styles), { margin: '8px 4px 8px 8px', '::-webkit-scrollbar-thumb': {
                border: 'none',
                borderRadius: '4px',
                height: '47px',
                backgroundColor: theme.colors.defaultControlColor,
                '&:hover': {
                    backgroundColor: theme.colors.dropdownIndicatorColor,
                },
            }, '::-webkit-scrollbar': {
                width: '10px',
            }, '::-webkit-scrollbar-track': {
                backgroundColor: theme.colors.menuHoverBackgroundColor,
                borderRadius: '6px',
            } });
    },
    dropdownIndicator: function (styles, state) {
        var theme = state.theme, isDisabled = state.isDisabled;
        return __assign(__assign({}, styles), { justifyContent: 'center', alignItems: 'center', '& svg': {
                stroke: isDisabled ? theme.colors.dropdownIndicatorColor : theme.colors.inputTextColor,
            }, padding: '0px 5px 0px 0px', '@media (min-width: 1024px)': {
                padding: '0px 10px 0px 1px',
            } });
    },
    clearIndicator: function (styles, state) {
        var theme = state.theme;
        return __assign(__assign({}, styles), { justifyContent: 'center', alignItems: 'center', padding: theme.narrowIndicators ? '0px 0px 0px 2px' : '0px 4px', color: theme.colors.dropdownIndicatorColor });
    },
};
export var getCustomTheme = function (theme, optionVariant, useFilterSubvariant) {
    var inputTextColor = th.color('blue2')({ theme: theme });
    var customColors = {
        primary: th.color('red1')({ theme: theme }),
        inputTextColor: inputTextColor,
        whiteBackgroundColor: th.color('white')({ theme: theme }),
        optionTextColor: th.color('blue2')({ theme: theme }),
        menuHoverBackgroundColor: th.color('bgLightGray1')({ theme: theme }),
        inputDisabledColor: th.color('lightGray1')({ theme: theme }),
        inputBorderColor: th.color('lightGray3')({ theme: theme }),
        placeholderTextColor: th.color('lightGray3')({ theme: theme }),
        defaultControlColor: th.color('lightGray5')({ theme: theme }),
        disabledTextColor: th.color('lightGray6')({ theme: theme }),
        dropdownIndicatorColor: th.color('gray1')({ theme: theme }),
        inputBorderHoverColor: th.color('gray5')({ theme: theme }),
        activeOptionBackground: th.color('red20')({ theme: theme }),
        hoverToActiveOptionBackground: th.color('red30')({ theme: theme }),
    };
    return function (reactSelectTheme) {
        return __assign(__assign({}, reactSelectTheme), { colors: customColors, focusBoxShadow: null, height: '38px', flexWrap: useFilterSubvariant ? 'nowrap' : 'wrap', textWeightNormal: th.fontWeight('normal')({ theme: theme }), optionVariant: optionVariant, borderRadius: th.radius('lg')({ theme: theme }), font: th.font('primary')({ theme: theme }), narrowIndicators: !!useFilterSubvariant });
    };
};
